import { Outlet, useOutletContext } from 'react-router-dom'

import { PageDateFiltersProvider } from './PageDateFiltersContext'
import { type RouteContextParams } from './RouteContextParams'

/**
 * Wrapper component to add PageDateFiltersProvider to a route while preserving parent context.
 *
 * Use this when you need to:
 * - Add date filter context at a route level
 * - Preserve parent RouteContextParams
 * - Render only an <Outlet /> (no page component)
 *
 * Typically used for group detail routes that don't have an intermediate page component.
 */
export const WithDateFilters = () => {
  const context = useOutletContext<RouteContextParams>()
  return (
    <PageDateFiltersProvider>
      <Outlet context={context} />
    </PageDateFiltersProvider>
  )
}
